import { site } from '../data/content';

export default function Nav() {
  return (
    <nav className="nav">
      <div className="wrap">
        <a className="brand" href="#top">
          <span className="logo">
            <img src="/logo.png" alt="" width="40" height="40" />
          </span>
          {site.brand}
        </a>

        <div className="nav-right">
          <a className="btn btn-primary" href="#pricing">
            Become LNG Ready
          </a>
        </div>
      </div>
    </nav>
  );
}
